import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ContractApprovalService } from 'src/app/services/contract-approval.service';
import { ApproveContractWithTokenDto } from 'src/app/models/ApproveContractWithTokenDto';
import { TokenService } from 'src/app/services/token.service';
import { SharedService } from 'src/app/services/shared.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ContractDto } from 'src/app/models/contractDto';
import { RequestApprovalDto } from 'src/app/models/requestapproval-dto';
import { RequestApprovalsService } from 'src/app/services/requestapprovals.service';
import { NotificationType } from 'src/app/models/notification.message';
import { approveContractVm } from 'src/app/models/approveContractVm';
import { ContractsService } from 'src/app/services/contracts.service';
import { approveContractAxiom } from 'src/app/models/approveContractAxiom';
@Component({
  selector: 'app-approve',
  templateUrl: './approve.component.html',
  styleUrls: ['./approve.component.css']
})
export class ApproveComponent implements OnInit {

  token: string="";
  hasUserApprovedContract:boolean=false;
  contract:any;
  UpdateRequest:any;
  contractorId: number = 0;
  approvedCost: number = 0;
  biometricRequired: boolean = false;
  safetyInductionNotes: string = '';
  medicalNotes: string = '';
  poNumber: string = '';
  qualification:string='';
  description:string="";
  justification:string="";
  Comment:string='';

   showSelectAxiom: boolean = false;

  axioms: any[] = []; 
  selectedAxiom = 0;
  axiomId = 0;
  isHrbp: boolean = false; 
  currentUser: any
 
 

  ApproveRequest: ContractDto | any;
  RequestApprovals: RequestApprovalDto[] | undefined;
  constructor(private location:Location ,  private route: ActivatedRoute,  private tokenService: TokenService, private router: Router,
    private notification: NotificationService, private sharedService: SharedService,    private contractApprovalService :ContractApprovalService,
    private requestApprovalService: RequestApprovalsService, private contractService:ContractsService,  private _ActivatedRoute: ActivatedRoute  ) 
    { 
     
  }


  
  ngOnInit(): void {
    this.route.queryParams
    .subscribe(params => {
      console.log(params);  
      this.token = params.to;
      console.log(this.token);  
    }
  );

  if(this.token.length==0)
  {
    this.router.navigate(['/approverequests']);

  }
  //console.log(this.token); 
  this.LoadData();
   this.location.replaceState(this.location.path().split('?')[0], '');
  ;


  var snapshot = this._ActivatedRoute.snapshot;
  const params = { ...snapshot.queryParams };
  delete params.pos
  this.router.navigate([], { queryParams: params });
}

  async LoadData()
  {
    
    let resLo = await this.contractApprovalService.BeginApproval(this.token).toPromise();
    var payload  = <ApproveContractWithTokenDto>resLo.responseData;
      console.log('payload' , payload)
     let resAxioms = await this.contractService.getAxioms().toPromise();
    this.axioms = <any[]>resAxioms.responseData;
    console.log('this is axioms ', this.axioms);

    this.currentUser = this.tokenService.getInfo();

    if(payload.login.profile.departmentName == 'ORGANIZATION & HUMAN RESOURCES'){
      this.isHrbp = true;
    }

    
if(payload.hasUserApprovedContract)
{
this.hasUserApprovedContract = true;
}
this.UpdateRequest = payload.contract;
window.localStorage.clear();
  // store token
  this.contract=payload.contract;
  this.sharedService.loginResponseData = payload.login;
  this.tokenService.saveSession(payload.login);
  this.tokenService.setInfo(payload.login);

this.description = payload.contract.description;
this.justification= payload.contract.justification;
this.qualification = payload.contract.qualification;
  let resApprovals = await this.requestApprovalService.getRequestApprovals(this.UpdateRequest.id).toPromise();
    this.RequestApprovals = <RequestApprovalDto[]>resApprovals.responseData;



}
cancel()
{
   this.router.navigateByUrl('/dashboard');
 // this.router.navigate(['/dashboard']);
}

cancelReturn()
{
  
 // this.router.navigate(['/dashboard']);
}

onChangeAxiom(event:number)
  {
   this.selectedAxiom = event;
   this.axiomId = event;
  }

 
  

async approveContract() {
;
   let axiomId;
    if(this.contract.axiomId != 0){
      axiomId = this.contract.axiomId
    }else{
      axiomId = this.axiomId;
    }

  
  const model: approveContractAxiom = { id: this.contract.id, message: this.Comment, token:this.token, axiomId };
;
  this.contractApprovalService.approve(model).subscribe({
    next: (data => {
      
      if (data.responseCode == "00") {
        this.notification.sendMessage({
          message: data.message,
          type: NotificationType.success
        });
     
        this.router.navigate(['/dashboard']);
     
      }
      else {

        this.notification.sendMessage({
          message: data.message,
          type: NotificationType.error
        });

      }

    }),
    error: ((error: any) => {
      console.log(error.error);
     


      this.notification.sendMessage({
        message: error.error.message,
        type: NotificationType.error
      });

      this.router.navigate(['/dashboard']);
    })

  });

}

async rejectContract() {

  let axiomId;
    if(this.contract.axiomId != 0){
      axiomId = this.contract.axiomId
    }else{
      axiomId = this.axiomId;
    }

if (this.Comment === '') {
  this.notification.sendMessage({
    message: 'Comment is required when rejecting request',
    type: NotificationType.error
  });

  
}
else {
  

 

    const model: approveContractAxiom = { id: this.contract.id, message: this.Comment, token:this.token, axiomId };
;
    this.contractApprovalService.rejectContract(model).subscribe({
      next: (data => {

        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          this.router.navigate(['/dashboard']);
        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });
          this.router.navigate(['/dashboard']);
        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
        this.router.navigate(['/dashboard']);
      })

    });

}
}



}